function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "instagram",
  transform: "translate(-0.449)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M20.4,5.881a7.309,7.309,0,0,0-.465-2.427A5.124,5.124,0,0,0,17.006.528,7.328,7.328,0,0,0,14.58.063C13.509.012,13.169,0,10.453,0S7.4.012,6.33.059A7.311,7.311,0,0,0,3.9.524,4.881,4.881,0,0,0,2.13,1.68,4.925,4.925,0,0,0,.977,3.451,7.329,7.329,0,0,0,.512,5.877C.461,6.948.449,7.288.449,10s.012,3.056.059,4.123a7.309,7.309,0,0,0,.465,2.427A5.123,5.123,0,0,0,3.9,19.48a7.329,7.329,0,0,0,2.427.465c1.067.047,1.407.059,4.123.059s3.056-.012,4.123-.059A7.308,7.308,0,0,0,17,19.48a5.117,5.117,0,0,0,2.927-2.927,7.334,7.334,0,0,0,.465-2.427c.047-1.067.059-1.407.059-4.123S20.445,6.948,20.4,5.881Zm-1.8,8.167a5.483,5.483,0,0,1-.344,1.856,3.318,3.318,0,0,1-1.9,1.9,5.5,5.5,0,0,1-1.856.344c-1.055.047-1.372.059-4.041.059s-2.989-.012-4.041-.059A5.48,5.48,0,0,1,4.56,17.8a3.078,3.078,0,0,1-1.149-.746,3.11,3.11,0,0,1-.746-1.149,5.5,5.5,0,0,1-.344-1.856c-.047-1.055-.059-1.372-.059-4.041s.012-2.989.059-4.041a5.48,5.48,0,0,1,.344-1.856,3.04,3.04,0,0,1,.75-1.149A3.105,3.105,0,0,1,4.564,2.22,5.506,5.506,0,0,1,6.42,1.876c1.055-.047,1.372-.059,4.041-.059s2.989.012,4.041.059a5.483,5.483,0,0,1,1.856.344,3.076,3.076,0,0,1,1.149.746,3.109,3.109,0,0,1,.746,1.149A5.505,5.505,0,0,1,18.6,5.971c.047,1.055.059,1.372.059,4.041S18.644,12.993,18.6,14.048Zm0,0",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M130.088,124.5a5.139,5.139,0,1,0,5.139,5.139A5.14,5.14,0,0,0,130.088,124.5Zm0,8.472a3.333,3.333,0,1,1,3.333-3.333A3.334,3.334,0,0,1,130.088,132.972Zm0,0",
  transform: "translate(-119.635 -119.635)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M364.849,89.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,364.849,89.8Zm0,0",
  transform: "translate(-347.854 -85.139)",
  fill: "#fff"
}));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.004,
    viewBox: "0 0 20 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ae113c3a.svg";
export { ForwardRef as ReactComponent };